'use strict';

$(document).ready(function () {

    // mobile menu

    $(".js-mobileNavigation").on('click', function (e) {
        e.preventDefault();
        $(".navigation").fadeToggle(200);
        $(this).toggleClass('is-active');
    });

    // slider

    $('.js-slider').slick({
        arrow: true,
        appendArrows: $('.js-arrow'),
        prevArrow: '<a href="#" class="section-hp__link section-hp__link--effect1"><</a>',
        nextArrow: '<a href="#" class="section-hp__link section-hp__link--effect2">></a>'
    });

    // mapa select

    $('.js-selectMap').on('change', function () {
        //console.log('change');
        $('.js-mapSelected').attr("src", maps[$(this).val()]);

        // ignoring Ekologicke poradenstvi & Vodohosp. sluzby - they have special contacts
        if($('.js-selectArea').val() != 9 && $('.js-selectArea').val() != 4){
            $('.map__side').html(contacts[$(this).val()]);
        }
    });


    // service select

    $('.js-selectArea').on('change', function () {
        //console.log('change');
        // SHOWING ALL COORDS ALL TIME
        //showCoordsIndex($(this).val());

        // special contacts for Ekologicke poradenstvi & Vodohosp. sluzby
        if($(this).val() == 9){
            $('.map__side').html(contacts[8]);
        }else if ($(this).val() == 4) {
            $('.map__side').html(contacts[7]);
        } else{
            $('.map__side').html(contacts[$('.js-selectMap').val()]);
        }
    });

    // mapa dots

    showCoordsIndex(0);
    function showCoordsIndex(index) {
        $("#overlay-dots").empty();
        $(coords[index]).each(function (i) {
            var pos = this;
            var dot = $('<div class="map__dot" data-tippy-content=" ' + pos[2] + ' " ></div>');
            dot.css({
                position: 'absolute',
                left: pos[0] + "px",
                top: pos[1] + "px"
            });
            $("#overlay-dots").append(dot);

            
            // mapa popover

            tippy('.map__dot', {
                theme: "purum",
                allowHTML: true,
                interactive: true,
                arrow: true,
                size: "large",
                offset: "0, 0",
                maxWidth: 450,
                delay: 150,
                trigger: "mouseenter click focus",
                onShow(instance) {
                    tippy.hideAll({ exclude: instance })
                }
            })
        });
    }


    $('#search_restart').click(function (e) {
        $('.js-selectMap').val(0),
        $('.js-selectArea').val(0),
        $('.js-mapSelected').attr("src", maps[0]),
        $('.map__side').html(contacts[0]),
        showCoordsIndex(0);
        e.preventDefault();
    });


});
